export type MenuSourceKind = "community" | "venue" | "staff";

export type MenuSourceResult = {
  kind: MenuSourceKind;
};

export type MenuSourceStrings = {
  community: string;
  venue: string;
  staff: string;
};

export function formatMenuSourceLabel(
  kind: MenuSourceKind,
  strings: MenuSourceStrings
): string {
  return strings[kind];
}

export function menuSourceFromPublishChannel(
  publishChannel: string | null | undefined
): MenuSourceKind | null {
  if (publishChannel === "venue") return "venue";
  if (publishChannel === "community") return "community";
  if (publishChannel === "staff") return "staff";
  if (publishChannel === "unknown") return null;
  return null;
}

/** Viewport RPC `source`: user | restaurant (from captured_by_user). */
export function menuSourceFromViewportSource(
  source: string | null | undefined,
  capturedByUser?: string | null
): MenuSourceKind | null {
  if (source === "user" || capturedByUser) return "community";
  if (source === "restaurant") return "venue";
  return null;
}

export function getMenuSource(input: {
  publishChannel?: string | null;
  viewportSource?: string | null;
  capturedByUser?: string | null;
  isRestaurantClaimed?: boolean;
}): MenuSourceResult | null {
  const fromChannel = menuSourceFromPublishChannel(input.publishChannel);
  if (fromChannel) {
    return { kind: fromChannel };
  }

  const fromViewport = menuSourceFromViewportSource(
    input.viewportSource,
    input.capturedByUser
  );
  if (fromViewport) {
    return { kind: fromViewport };
  }

  if (input.isRestaurantClaimed) {
    return { kind: "venue" };
  }

  return null;
}

/** Solid fills — same contrast in light and dark (no pale bg + inherited light text). */
export function sourceBadgeClassName(kind: MenuSourceKind): string {
  switch (kind) {
    case "community":
      return "bg-teal-600 text-white border-teal-500";
    case "venue":
      return "bg-green-600 text-white border-green-500";
    case "staff":
      return "bg-blue-600 text-white border-blue-500";
  }
}
